import React from "react";
import { Stars } from "../../assets/images";

type OwnerProfileProps = {
  name: string;
  // rating: string;
  rental: number;
  totalReview: number;
  // lastDelivery: string;
  // memberSince: string;
};

const OwnerProfile: React.FC<OwnerProfileProps> = ({
  name,
  // rating,
  rental,
  totalReview,
  // lastDelivery,
  // memberSince,
}) => {
  return (
    <div className="flex h-[200px] w-full gap-5 justify-between flex-shrink-0 overflow-x-scroll">
      <div className=" w-[250px] xl:w-[30%]  flex flex-col flex-shrink-0 h-full gap-3 bg-white justify-center items-center px-7">
        <p className="w-full text-left text-darkGreen font-Jakarta text-sm font-semibold  ">
          OWNER
        </p>
        <div className="flex items-center  gap-3 h-[70px]">
          {/* <img src={img} alt="" className=" h-full " /> */}
          <p className="h-[80%] flex items-center justify-center w-[50px] text-center text-white bg-midGreen border rounded-full p-2 ">
            {name?.slice(0, 2).toUpperCase()}
          </p>
          <div className="flex flex-col gap-2">
            <p className=" text-black  font-Jakarta text-base font-medium underline  ">
              {name}
            </p>
            {/* <div className="flex gap-2 w-2/3">
              <img src={Stars} alt="" className="w-[70%]" />
              <p className=" text-[#586780] font-Jakarta font-medium text-sm ">
                {rating}
              </p>
            </div> */}
          </div>
        </div>
      </div>
      <div className="w-[280px] xl:w-[35%] flex flex-col flex-shrink-0 justify-center items-center gap-8 bg-white ">
        <div className="flex justify-around w-full">
          <div className="flex flex-col gap-2">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal leading-4  ">
              RENTAL
            </p>
            <p className=" text-[#596780]  font-Jakarta font-semibold text-base  ">
              {rental}
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal leading-4  ">
              Total Review
            </p>
            <p className=" text-[#596780]  font-Jakarta font-semibold text-base  ">
              {totalReview}
            </p>
          </div>
          {/* <div className="flex flex-col gap-2">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal leading-4  ">
              Last Delivery
            </p>
            <p className=" text-[#596780]  font-Jakarta font-semibold text-base  ">
              {lastDelivery}
            </p>
          </div> */}
        </div>
        {/* <p className=" text-[#596780] w-[80%] mx-auto text-left font-Jakarta text-xs font-medium ">
          {memberSince}
        </p> */}
      </div>
      {/* <div className="w-[220px] xl:w-[30%]  flex flex-col flex-shrink-0 justify-center bg-white gap-4 p-10">
        <p className=" font-Jakarta text-darkGreen text-sm font-semibold uppercase ">
          Insurance
        </p>
        <ul className="  list-disc pl-8">
          <li className=" text-black font-Poppins text-base font-normal ">
            Insured
          </li>
          <li className=" text-black font-Poppins text-base font-normal ">
            Insured
          </li>
          <li className=" text-black font-Poppins text-base font-normal ">
            Insured
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default OwnerProfile;
